import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { PrimaryButton, CommandBarButton, Separator } from '@bingads-webui-react/fabric-control';
import {
  ObjectSelectionImageView,
} from '@bingads-webui-campaign-react/ads-studio-app-shared-components';

import { ErrorMessageBar } from '../shared-componenets';
import { VIEWS } from '../model/constants';
import { useObjectSelection } from '../model/use-object-selection';

export const ObjectsSelectionView = ({
  i18n,
  originalImageUrl,
  originalImageHeight,
  originalImageWidth,
  getMaskValueAtPoint,
  segmentationMasks,
  maskValues,
  imageUrlWithoutBackground,
  isFetchingSegmentations,
  setActiveView,
  setSelectedImageSrc,
  selectedMasks,
  setSelectedMasks,
  errorMessage,
  logger,
}) => {
  const {
    // mask
    borderImageSrc,
    toggleSelectedMask,
    highlightedImageSrc,
    workingSelectedImageSrc,
    startOver,
    updateSubject,
    updateHighlightedImage,
    objectSelectionError,
  } = useObjectSelection({
    originalImageUrl,
    originalImageWidth,
    originalImageHeight,
    segmentationMasks,
    imageUrlWithoutBackground,
    setSelectedImageSrc,
    selectedMasks,
    setSelectedMasks,
    i18n,
  });
  const description = i18n.getString(_TL_('You can select the subjects or objects you want to keep and select Update.'));

  return (
    <div className={classNames('object-selection-view-container', 'background-change-view-container')}>
      <div className="background-change-view-content-container">
        <div className="objects-selection-view">
          <div className="description">
            {description}
          </div>
          <div className="image-section">
            <ObjectSelectionImageView
              i18n={i18n}
              originalImageUrl={originalImageUrl}
              originalImageHeight={originalImageHeight}
              originalImageWidth={originalImageWidth}
              getMaskValueAtPoint={getMaskValueAtPoint}
              updateHighlightedImage={updateHighlightedImage}
              isFetchingSegmentations={isFetchingSegmentations}
              toggleSelectedMask={toggleSelectedMask}
              borderImageSrc={borderImageSrc}
              workingSelectedImageSrc={workingSelectedImageSrc}
              highlightedImageSrc={highlightedImageSrc}
              maskValues={maskValues}
              logger={logger}
            />
          </div>
        </div>
      </div>
      <ErrorMessageBar errorMessage={errorMessage} customClassName="error-message" />
      <ErrorMessageBar errorMessage={objectSelectionError} customClassName="error-message" />
      <div className="background-change-view-actions-container">
        <div className="left-control">
          <CommandBarButton
            iconProps={{ iconName: 'Back' }}
            className="back-button"
            onClick={() => {
              setActiveView(VIEWS.BackgroundRemoval);
              logger.logTrace('Copilot change image background - object selection view - back button clicked');
            }}
          />
          <Separator vertical />
          <CommandBarButton
            iconProps={{ iconName: 'Refresh' }}
            text={i18n.getString(_TL_('Start over'))}
            className="start-over-button"
            onClick={() => {
              startOver();
              logger.logTrace('Copilot change image background - object selection view - start over button clicked');
            }}
            disabled={errorMessage !== '' || isFetchingSegmentations}
          />
        </div>
        <div className="right-control">
          <PrimaryButton
            iconProps={{ iconName: 'Accept' }}
            className="update-subject-button"
            onClick={() => {
              updateSubject();
              setActiveView(VIEWS.ImageBackgroundGeneration);
              logger.logTrace('Copilot change image background - object selection view - update subject button clicked');
            }}
            disabled={errorMessage !== '' || objectSelectionError !== ''}
          >
            {i18n.getString(_TL_('Update'))}
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
};


ObjectsSelectionView.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  originalImageUrl: PropTypes.string.isRequired,
  originalImageHeight: PropTypes.number.isRequired,
  originalImageWidth: PropTypes.number.isRequired,
  getMaskValueAtPoint: PropTypes.func.isRequired,
  segmentationMasks: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.number),
    PropTypes.shape({}),
  ]).isRequired,
  logger: PropTypes.shape({
    logTrace: PropTypes.func,
  }).isRequired,
  imageUrlWithoutBackground: PropTypes.string.isRequired,
  isFetchingSegmentations: PropTypes.bool.isRequired,
  setActiveView: PropTypes.func.isRequired,
  setSelectedImageSrc: PropTypes.func.isRequired,
  selectedMasks: PropTypes.arrayOf(PropTypes.number).isRequired,
  maskValues: PropTypes.arrayOf(PropTypes.number),
  setSelectedMasks: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
};

ObjectsSelectionView.defaultProps = {
  errorMessage: '',
  maskValues: [],
};
